import type { FaireProductEntity } from "../../entity_types/product";

export const p_eem9d6ck76: FaireProductEntity = {
  token: "p_eem9d6ck76",
  type: "product",
  name: "Golden Sunset Candle | Fresh Mango & Coconut Milk",
  brandToken: "b_tthhaz7z5x",
  brandName: "Jungle Club",
  imageUrl:
    "https://cdn.faire.com/fastly/e48edfb75919a8685eaf13792640e9f89bbaa4062de97fa88228c9ee3bf94df7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69a674fd37fa8b46336678ecfef39a420103d5117b2309470fb7474e544643cc.jpeg",
    "https://cdn.faire.com/fastly/efb3c1cb94223c313b7643ac5d38b601ebed61d4a21852ee3c7f4a83f633f5d1.jpeg",
    "https://cdn.faire.com/fastly/7dcd1f6d3a1a5f518ef269b33e2d3f8279cdf753054f8e68b2291b3146de68f1.jpeg",
    "https://cdn.faire.com/fastly/c2cbdc1e55ac43190237f83239895e20ae4acf9b9dadee752381f9992b667fce.jpeg",
    "https://cdn.faire.com/fastly/23d7ded7cf365c59178ff05b1e129ef3deb853fa98113a0ab4b8ce4b86553a41.jpeg",
  ],
  priceDollars: 15,
  description:
    "Transport yourself to a serene paradise with the Golden Sunset Candle, elegantly presented in a warm, golden-hued ceramic vessel. Hand-poured in sunny San Diego, this candle combines premium fragrance with a blend of paraffin-free coconut soy wax for an eco-friendly and clean burn.\n\nWith delightful notes of fresh mango and creamy coconut milk, it captures the essence of a tranquil evening by the beach. The label features a majestic lion alongside a traveler’s palm tree, adding a touch of adventure to your décor.\n\n.        Cork Lid\n.        Scent | Fresh Mango & Coconut Milk\n.        Size | 10 Ounces\n.        Ceramic Vessel Imported\n.        Designed and Poured in the USA",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:05.821Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
